<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="toolBar">
      <form action="/">
        <van-search v-model="search.key" placeholder="姓名、时间、名称等" show-action @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-dropdown-menu>
          <van-dropdown-item v-model="search.diveShopId" :options="optionDiveShop" @change="onDiveShopChange" />
          <van-dropdown-item v-model="search.diveCourseId" :options="optionCourse" @change="onDiveCourseChange" />
          <van-dropdown-item v-model="search.diveClassId" :options="optionClass" @change="onSearch" />
          <van-dropdown-item v-model="search.learnState" :options="optionState" @change="onSearch" />
        </van-dropdown-menu>
      </form>
    </div>
    <div class="dataRect">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.student.studentId" class="dataLine">
          <div class="iconRect">
            <van-image
              width="4em"
              height="5.2em"
              fit="cover"
              radius="0.4em"
              lazy-load
              :src="item.headIcon?item.headIcon:'/img/defaultUserIcon.jpg'"
              @click="onTrip(item.student.studentId)"
            />
          </div>
          <div class="infoRect" @click="onTrip(item.student.studentId)">
            <van-row>
              <van-col span="16" class="title">{{ item.student.firstName }} {{ item.student.lastName }} {{ item.student.loaclName }}</van-col>
              <van-col span="8" class="rigth"><van-tag :color="GetDiveMainBack()">{{ GetEnumText('Em_LearningState',item.student.state) }}</van-tag></van-col>
            </van-row>
            <van-row gutter="10" class="line">
              <van-col span="12" class="breakAll"><span class="key" :style="'color:'+GetDiveMainBack()">{{ GetEnumText('Em_TripType',item.tripType) }}:</span> {{ item.courseNameShort?item.courseNameShort:item.courseName }}</van-col>
              <van-col span="12"><span class="key" :style="'color:'+GetDiveMainBack()">队伍:</span> {{ item.className }}</van-col>
            </van-row>
            <van-row gutter="10" class="line">
              <van-col span="12"><span class="key" :style="'color:'+GetDiveMainBack()">国家:</span> {{ item.student.country }}{{ item.student.province }}{{ item.student.city }}</van-col>
              <van-col span="12" class="breakAll"><span class="key" :style="'color:'+GetDiveMainBack()">生日:</span> {{ formatDate(item.student.birthday,'yyyy/MM/dd') }}</van-col>
            </van-row>
            <van-row gutter="10" class="line">
              <van-col span="12"><span class="key" :style="'color:'+GetDiveMainBack()">开始:</span> {{ formatDate(item.student.startTime,"yyyy/MM/dd") }}</van-col>
              <van-col span="12" class="breakAll"><span class="key" :style="'color:'+GetDiveMainBack()">更新:</span> {{ formatDate(item.student.startTime,"yyyy/MM/dd hh:mm",true) }}</van-col>
            </van-row>
          </div>

        <!-- <van-row>
          <van-col span="20" class="title">JOE教练200319期</van-col>
          <van-col span="4" class="rigth"><van-tag :color="GetDiveMainBack()">已开课</van-tag></van-col>
        </van-row>
        <van-row>
          <van-col span="12">课程:Specialty Course Enriched Air Nitrox Level 2 (40%)</van-col>
          <van-col span="6">队员:10人</van-col>
          <van-col span="6" class="rigth">日期:2020/04/23</van-col>
        </van-row> -->
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Search, DropdownMenu, DropdownItem, Tag, Image, Lazyload, List } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, GetEnumList, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { checkInDropDownList, getDiveCenterList, getDiveCourseList } from '@/utils/baseData'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Search.name]: Search,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [List.name]: List,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '行程列表',
      backurl: '/store/index',
      search: {
        key: undefined,
        limit: 30,
        page: 1,
        learnState: undefined,
        diveCourseId: undefined,
        diveClassId: undefined,
        diveShopId: undefined
      },
      loading: undefined,
      finished: false,
      list: [],
      optionCourseBase: [],
      optionClass: [],
      optionCourse: [],
      optionState: [],
      optionDiveShop: []
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.initClassList()
    getDiveCenterList((centerList) => {
      this.optionDiveShop = JSON.parse(JSON.stringify(centerList))
      this.optionDiveShop.unshift({ text: '不限中心', value: undefined, isEnable: true })
      getDiveCourseList((courseList) => {
        this.optionCourseBase = JSON.parse(JSON.stringify(courseList))
        this.optionCourse = JSON.parse(JSON.stringify(this.optionCourseBase))
        this.optionCourse.unshift({ text: '不限课程', value: undefined, isEnable: true })
      })
      this.optionState = GetEnumList('Em_LearningState')
      this.optionState.unshift({ text: '不限状态', value: undefined, isEnable: true })
    })
  },
  activated() {
    var defaultState = getUrlKey('state')
    if (defaultState) {
      this.search.learnState = defaultState
    }
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onSearch() {
      console.log('onSearch', this.search)
      this.init()
    },
    initClassList() {
      this.optionClass = [{ text: '不限队伍', value: undefined, isEnable: true }]
      request({
        url: '/DiveTrip/getDiveClassSelectList',
        method: 'post',
        data: { limit: 100,
          classId: this.search.diveClassId,
          diveShopId: this.search.diveShopId }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.optionClass = response.data
        this.optionClass.unshift({ text: '不限队伍', value: undefined, isEnable: true })
        this.search.diveClassId = checkInDropDownList(this.optionClass, this.search.diveClassId)
      })
    },

    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      console.log('onLoad')
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      request({
        url: '/DiveTrip/getCoachDiveTripList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onDiveShopChange() {
      if (this.search.diveShopId) {
        this.optionCourse = JSON.parse(JSON.stringify(this.optionCourseBase.filter(m => m.diveShopId === this.search.diveShopId)))
        this.optionCourse.unshift({ text: '不限课程', value: undefined, isEnable: true })
        this.search.diveCourseId = checkInDropDownList(this.optionCourse, this.search.diveCourseId)
      } else {
        this.optionCourse = JSON.parse(JSON.stringify(this.optionCourseBase))
        this.optionCourse.unshift({ text: '不限课程', value: undefined, isEnable: true })
      }
      this.initClassList()
      this.onSearch()
    },
    onDiveCourseChange() {
      this.initClassList()
      this.onSearch()
    },
    onTrip(studentId) {
      this.$router.push('/pro/trip/trip/' + studentId)
    }
  }
}
</script>
<style scoped>
.dataRect{
    height: calc(100vh - 3em - 104px);
    overflow-y: scroll;
}
.dataRect .dataLine{
    background-color: #fff;
    padding:1em;
    border-bottom: 1px solid #f5f5f5;
    position: relative;
}
.dataRect .title{
    font-weight: 700;
}
.dataRect .dataLine:last-child{
    border-bottom: none;
}
.dataRect .dataLine .iconRect{
    position: absolute;
    left: 1em;
    top: 1em;
}
.dataRect .dataLine .infoRect{
    margin-left: 6em;
    min-height: 7.2em;
    font-size: 0.7em;
}
.dataRect .dataLine .infoRect .line{
    padding: 0.2em 0;
}
.dataRect .dataLine .infoRect .key{
    color: #999;
}
</style>
